// extracted by mini-css-extract-plugin
export default {"root":"root--flLsP","isDesignV2":"isDesignV2--SaKs6","box":"box--EM6jd","addBtn":"addBtn--BjYic","title":"title--JdjPi","designV2Box":"designV2Box--pZpXa"};